import { useMemo, useState } from 'react';
import { useProjects } from '../../../../hooks/useProjects';
import { useProjectProgressTrackingHistory } from '../../../../hooks/useProjectProgressTrackingHistory';

export const useHistoricalProgressDashboard = () => {
  const [selectedProject, setSelectedProject] = useState('');

  const { data: projects = [], isLoading: projectsLoading } = useProjects();
  const { data: historyData, isLoading: historyLoading } = useProjectProgressTrackingHistory(
    selectedProject,
    {
      enabled: !!selectedProject,
    }
  );

  const sortedProjects = useMemo(() => {
    return [...projects].sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
  }, [projects]);

  const timeline = useMemo(() => {
    const points = Array.isArray(historyData?.timeline) ? historyData.timeline : [];
    return [...points].sort((a, b) => (a?.date || '').localeCompare(b?.date || ''));
  }, [historyData]);

  const entries = useMemo(() => {
    const values = Array.isArray(historyData?.entries) ? historyData.entries : [];
    return [...values].sort((a, b) => (b?.created_at || '').localeCompare(a?.created_at || ''));
  }, [historyData]);

  const handleProjectChange = (event) => {
    setSelectedProject(event.target.value);
  };

  return {
    projects: sortedProjects,
    selectedProject,
    timeline,
    entries,
    isLoading: projectsLoading || historyLoading,
    handleProjectChange,
  };
};
